<app-header [showBackButton]="showBackButton" [headerTitle]="headerTitle"></app-header>
<router-outlet>
</router-outlet>

<app-footer *ngIf="!showFullFooter()"></app-footer>
<app-full-footer *ngIf="showFullFooter()"></app-full-footer>

<div class="spinner-wrapper" *ngIf="showSpinner">
    <mat-spinner></mat-spinner>
</div>